import axios from "axios";

const apiRequest = async (
  method: string,
  url: string,
  data: any,
  headers = {}
) => {
  try {
    const response = await axios({
      method: method,
      url: url,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "X-Spectrum-Header": localStorage.getItem("language"),
      },
    });

    return response.data;
  } catch (error) {
    console.error("API isteğinde hata:", error);
    throw error;
  }
};

export default apiRequest;
